import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { u as useKeyboardClick } from './utils.js';

const mapyMapToggleCss = ":host{background:#ffffff;color:rgba(1, 30, 57, 0.6);border-radius:8px;box-shadow:0px 4px 16px 0px rgba(0, 0, 0, 0.10);user-select:none;display:inline-flex;padding:4px 8px;align-items:center;gap:8px;font-family:Arial, Helvetica, sans-serif;font-size:14px;font-style:normal;font-weight:400;line-height:20px;cursor:pointer;min-height:24px}:host(:hover:not([disabled])),:host(:focus-visible){background:#f5f6f7}:host(:active:not([disabled])),:host([checked]:not([disabled])){color:rgba(30, 174, 0, 1)}:host(:hover:active:not([disabled])){color:rgba(27, 157, 0, 1)}:host(:focus-visible){outline:2px solid currentColor}:host([disabled]){color:rgba(1, 30, 57, 0.12);pointer-events:none;cursor:default}";

var __classPrivateFieldGet = (undefined && undefined.__classPrivateFieldGet) || function (receiver, state, kind, f) {
  if (kind === "a" && !f)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (undefined && undefined.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
  if (kind === "m")
    throw new TypeError("Private method is not writable");
  if (kind === "a" && !f)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _MapyMapToggle_originalTabIndex, _MapyMapToggle_cleanup, _MapyMapToggle_handleClick;
const MapyMapToggle$1 = /*@__PURE__*/ proxyCustomElement(class MapyMapToggle extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.change = createEvent(this, "change", 2);
    _MapyMapToggle_originalTabIndex.set(this, undefined);
    _MapyMapToggle_cleanup.set(this, null);
    _MapyMapToggle_handleClick.set(this, (event) => {
      if (!event.defaultPrevented && !this.disabled) {
        this.checked = !this.checked;
        this.change.emit(this.checked);
      }
    });
    this.disabled = false;
    this.checked = false;
  }
  watchPropHandler(newValue) {
    if (newValue) {
      this.hostElement.tabIndex = -1;
    }
    else {
      this.hostElement.tabIndex = __classPrivateFieldGet(this, _MapyMapToggle_originalTabIndex, "f");
    }
  }
  connectedCallback() {
    this.hostElement.addEventListener('click', __classPrivateFieldGet(this, _MapyMapToggle_handleClick, "f"), false);
    // map toggle narozdil od formularoveho toggle bude reagovat i na enter
    __classPrivateFieldSet(this, _MapyMapToggle_cleanup, useKeyboardClick(this.hostElement), "f");
    if (!this.hostElement.hasAttribute('tabindex')) {
      this.hostElement.tabIndex = 0;
    }
    __classPrivateFieldSet(this, _MapyMapToggle_originalTabIndex, this.hostElement.getAttribute('tabindex'), "f");
    if (this.disabled) {
      this.hostElement.tabIndex = -1;
    }
  }
  disconnectedCallback() {
    var _a;
    this.hostElement.removeEventListener('click', __classPrivateFieldGet(this, _MapyMapToggle_handleClick, "f"), false);
    (_a = __classPrivateFieldGet(this, _MapyMapToggle_cleanup, "f")) === null || _a === void 0 ? void 0 : _a.call(this);
  }
  render() {
    return h(Host, null, h("slot", null));
  }
  get hostElement() { return this; }
  static get watchers() { return {
    "disabled": ["watchPropHandler"]
  }; }
  static get style() { return mapyMapToggleCss; }
}, [1, "mapy-map-toggle", {
    "disabled": [516],
    "checked": [516]
  }]);
_MapyMapToggle_originalTabIndex = new WeakMap(), _MapyMapToggle_cleanup = new WeakMap(), _MapyMapToggle_handleClick = new WeakMap();
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["mapy-map-toggle"];
  components.forEach(tagName => { switch (tagName) {
    case "mapy-map-toggle":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, MapyMapToggle$1);
      }
      break;
  } });
}
defineCustomElement$1();

const MapyMapToggle = MapyMapToggle$1;
const defineCustomElement = defineCustomElement$1;

export { MapyMapToggle, defineCustomElement };

//# sourceMappingURL=mapy-map-toggle.js.map